import { render, staticRenderFns } from "./Dados.vue?vue&type=template&id=6031d68a&scoped=true&"
import script from "./Dados.vue?vue&type=script&lang=js&"
export * from "./Dados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6031d68a",
  null
  
)

export default component.exports